 import Vue from 'vue'
import Vuex from 'vuex'
import menus from './modules/menus'
import popups from './modules/popups'
import auth from './modules/auth'
import users from './modules/users'
import masks from './modules/masks'
import options from './modules/options'
import queries from './modules/moderator/queries'
import rules from './modules/moderator/rules'
import rulesStaff from './modules/moderator/rules_staff'
import contacts from './modules/moderator/contacts'
import contracts from './modules/moderator/contracts'
import usercontract from './modules/moderator/usercontract'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        menus,
        popups,
        auth,
        users,
        masks,
        options,
        queries,
        rules,
        rulesStaff,
        contacts,
        contracts,
        usercontract,
    },
    state: {
        onTabClick: false,
        notifyPageVersion: '',
    },
    mutations: {
        setTabClick(state, data){
            state.setTabClick = true;
        },
        setNotifyPageVersion(state, data){
            state.notifyPageVersion = data;
        },
        setSearchFocus(state, data){
            state.setSearchFocus = true;
        },
    },
    actions: {

    }
})
